import { useTranslation } from 'react-i18next';
import { ReviewSuccessScreen } from '@/components/processes/ReviewSuccessScreen';

interface SuccessStepContentProps {
  open: boolean;
  successType: 'accepted' | 'rejected';
  onOpenChange: (open: boolean) => void;
  onFinish: () => void;
}

export function SuccessStepContent({
  open,
  successType,
  onOpenChange,
  onFinish
}: SuccessStepContentProps) {
  const { t } = useTranslation();

  return (
    <ReviewSuccessScreen
      open={open}
      onOpenChange={onOpenChange}
      title={
        successType === 'accepted'
          ? t('assignmentReview.successAcceptedTitle')
          : t('assignmentReview.successRejectedTitle')
      }
      description={
        successType === 'accepted'
          ? t('assignmentReview.successAcceptedDesc')
          : t('assignmentReview.successRejectedDesc')
      }
      finishLabel={t('assignmentReview.finish')}
      onFinish={onFinish}
    />
  );
}
